export const CartItemResource = (data = {}) => {
	return {
		id: data.uid || data.product_id,
		title: data.title,
		type: data.type,
		quantity: data.quantity || 0,
		unit_price: data.unit_price || 0,
		service_charge_amount: data.service_charge_amount || 0,
		vat_amount: data.vat_amount || 0,
		total_price: data.total_price || 0,
		event_id: data.event_uid || data.event_id || null,
		event_slug: data.event_slug || null,
		event_title: data.event_title || null,
		image: data.image_path || null,
		max_purchase: data.max_purchase || null,
		varient: data.varient || null,
		varient_name: data.varient_name || null,
	};
};
